import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { BaseService } from '../../../shared/services/base.service';
import { SummaryInvestmentAssetIntangibleModel } from '../models/summary-investment-asset-intangible.model';



@Injectable()
export class InvestmentAssetIntangibleService extends BaseService<SummaryInvestmentAssetIntangibleModel,SummaryInvestmentAssetIntangibleModel> {
  constructor(http: HttpClient) {
    super(http, '/api/v2/investment-asset-intangibles');
  }

}
